import React, { useState } from "react";
import ApiKeysTab from "./ApiKeysTab";
import SubscriptionsTab from "./SubscriptionsTab";
import ConflictsTab from "./ConflictsTab";
import SyncActivityTab from "./SyncActivityTab";
import SftpEndpointsTab from "./SftpEndpointsTab";
import "../../../styles/Integrations.css";

const TABS = [
  { key: "api-keys", label: "API Keys", icon: "fa-key" },
  { key: "subscriptions", label: "Subscriptions", icon: "fa-satellite-dish" },
  { key: "sftp", label: "SFTP Endpoints", icon: "fa-server" },
  { key: "conflicts", label: "Conflicts", icon: "fa-exclamation-triangle" },
  { key: "sync-activity", label: "Sync Activity", icon: "fa-stream" },
];

function IntegrationsPage() {
  const [active, setActive] = useState("api-keys");

  return (
    <div className="integrations-page">
      <div className="integrations-tabs">
        {TABS.map((t) => (
          <button
            key={t.key}
            type="button"
            className={`integrations-tab ${active === t.key ? "active" : ""}`}
            onClick={() => setActive(t.key)}
          >
            <i className={`fas ${t.icon}`} style={{ marginRight: 6 }} />
            {t.label}
          </button>
        ))}
      </div>

      {active === "api-keys" && <ApiKeysTab />}
      {active === "subscriptions" && <SubscriptionsTab />}
      {active === "sftp" && <SftpEndpointsTab />}
      {active === "conflicts" && <ConflictsTab />}
      {active === "sync-activity" && <SyncActivityTab />}
    </div>
  );
}

export default IntegrationsPage;